module.exports = __webpack_public_path__ + "static/EGR_FlashPage_3-8bee3276ff3ed9f87b51b8ccf9c80979.jpg";